module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_01.c994cae0.png";